/*
  Positioning for select dropdowns rendered where the select is (teleported off) rather than at the end of the page.
  Element UI gave such a dropdown position: fixed whenever the select sat in a fixed container (a dialog or drawer), so
  the container's scrolling body didn't cut it off. Element Plus positions it absolutely unless told otherwise.
*/

export default new class PopperAssistant {
  public inPlacePopperOptions(el: Element | null | undefined): { strategy: 'fixed' | 'absolute' } {
    return { strategy: this.isInFixedContainer(el) ? 'fixed' : 'absolute' }
  }

  private isInFixedContainer(el: Element | null | undefined): boolean {
    for (let node = el?.parentElement; node && node !== document.body; node = node.parentElement) {
      if (getComputedStyle(node).position === 'fixed') {
        return true
      }
    }
    return false
  }
}()
